

export class ColumnMapping {

    constructor(public sourceColumn: string = "",
        public destinationColumn: string = "") {

    }

}